import { NotSelectableDay } from './NotSelectableDay';
import { SelectableDay } from './SelectableDay';

interface IsDaySelectableProps {
  currentMonth: boolean;
  dateInRange: boolean;
  browseCalendar: boolean;
  isDayWeekend: boolean;
  shouldDisableWeekends: boolean;
}

interface OwnProps extends IsDaySelectableProps {
  day: Date;
  selectDate: (date: Date) => void;
  currentDay: boolean;
  showIsDaySelected?: boolean;
}

const isDaySelectable = ({
  dateInRange,
  currentMonth,
  browseCalendar,
  isDayWeekend,
  shouldDisableWeekends
}: IsDaySelectableProps) => {
  if (dateInRange && (currentMonth || browseCalendar)) {
    if (shouldDisableWeekends) {
      return !isDayWeekend;
    } else {
      return true;
    }
  }

  return false;
};

export const Day = ({
  day,
  selectDate,
  currentDay,
  currentMonth,
  dateInRange,
  browseCalendar,
  showIsDaySelected,
  isDayWeekend,
  shouldDisableWeekends
}: OwnProps): JSX.Element => {
  const isSelectable = isDaySelectable({
    dateInRange,
    currentMonth,
    browseCalendar,
    isDayWeekend,
    shouldDisableWeekends
  });

  return isSelectable ? (
    <SelectableDay
      day={day}
      selectDate={selectDate}
      currentDay={currentDay}
      showIsDaySelected={showIsDaySelected}
    />
  ) : (
    <NotSelectableDay day={day} currentMonth={currentMonth} isDayWeekend={isDayWeekend} />
  );
};
